module.exports = __webpack_public_path__ + "static/media/map14.784d4d24.webp";